/* eslint-disable import/no-cycle */
import {
  HAS_BONUS_CHECK_SUPPORT_SUCCESS,
  GET_BONUS_CHECK_SUCCESS,
  NOTIFY_DANGER,
  CLEAR_BONUS_CHECK,
  BONUS_SEARCH_LOADING,
  REDEEM_BONUS_CHECK_BY_REFERENCE_NUMBER_SUCCESS,
} from './action-types'
import { genericError } from './action-utils'
import BonusCheckServiceApi from '../../api/bonus-check-service-api'
import { request } from './auth-actions'
import { notify } from './notification-actions'
import { getText } from '../../internal/TextLabels'
import MerchantPortalBonusCheckServiceApi from '../../api/merchant-portal-bonus-check-service-api'
import { Features, isEnabled } from '../../models/features'

const hasBonusCheckSupportSuccess = response => ({
  response,
  type: HAS_BONUS_CHECK_SUPPORT_SUCCESS,
})

const getBonusCheckSuccess = response => ({
  response,
  type: GET_BONUS_CHECK_SUCCESS,
})

const redeemBonusCheckSuccessByReferenceNumber = response => ({
  response,
  type: REDEEM_BONUS_CHECK_BY_REFERENCE_NUMBER_SUCCESS,
})

export const clearBonusCheck = () => ({
  type: CLEAR_BONUS_CHECK,
})

export const searchBonusLoading = status => ({
  type: BONUS_SEARCH_LOADING,
  status,
})

export const getBonusCheck = referenceNumber => dispatch => {
  dispatch(searchBonusLoading(true))
  const performRequest = () => {
    if (isEnabled(Features.NEW_BONUS_API)) {
      const requestBody = {
        reference: referenceNumber,
        customer: {
          governmentId: '',
          customerType: '',
        },
      }
      return dispatch(
        request(
          MerchantPortalBonusCheckServiceApi.bonusCheckSearch(requestBody),
        ),
      )
    }
    return dispatch(
      request(BonusCheckServiceApi.getBonusCheck(referenceNumber)),
    )
  }

  const handleResponse = response => {
    dispatch(getBonusCheckSuccess(response))
    dispatch(searchBonusLoading(false))
  }

  const handleError = () => {
    dispatch(searchBonusLoading(false))
    dispatch(getBonusCheckSuccess({}))
  }

  return performRequest().then(handleResponse).catch(handleError)
}

export const hasBonusCheckSupport = () => dispatch => {
  const performRequest = () => {
    if (isEnabled(Features.NEW_BONUS_API)) {
      return dispatch(
        request(MerchantPortalBonusCheckServiceApi.getBonusCheckSupport),
      )
    }
    return dispatch(request(BonusCheckServiceApi.hasBonusCheckSupport))
  }

  const handleResponse = response => {
    dispatch(hasBonusCheckSupportSuccess(response))
  }

  const handleError = error => {
    genericError(error)
    throw error
  }

  return performRequest().then(handleResponse).catch(handleError)
}

export const redeemBonusCheckByReferenceNumber =
  referenceNumber => dispatch => {
    const performRequest = () => {
      if (isEnabled(Features.NEW_BONUS_API)) {
        const requestBody = {
          reference: referenceNumber,
          customer: {
            governmentId: '',
            customerType: '',
          },
        }
        return dispatch(
          request(
            MerchantPortalBonusCheckServiceApi.bonusCheckRedeem(requestBody),
          ),
        )
      }
      return dispatch(
        request(
          BonusCheckServiceApi.redeemBonusCheckByReferenceNumber(
            referenceNumber,
          ),
        ),
      )
    }

    const handleResponse = response => {
      if (!response.success) {
        notify(NOTIFY_DANGER, getText('bonusChecks.redeemFailed'))
      }
      dispatch(redeemBonusCheckSuccessByReferenceNumber(response))
    }

    const handleError = error => {
      genericError(error)
      throw error
    }

    return performRequest().then(handleResponse).catch(handleError)
  }
